<h2 id="authorized-activity-heading" class="flex-align-center grid-gap-1">
  <fa-icon [icon]="faFileLines" aria-label="authorized-activities"></fa-icon>
  <span class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">BAER ACTIVITY AUTHORIZED</span>
</h2>
<div class="search-bar">
  <span>
    <mat-form-field appearance="outline" style="max-width: 180px;">
      <mat-label>Calendar Year</mat-label>
      <mat-select [(value)]="filters.calendarYear" (selectionChange)="onCalendarYearChange($event.value)">
        <mat-option [value]="null">--</mat-option>
        @for (year of calendarYears; track year) {
          <mat-option [value]="year">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 180px;">
      <mat-label>Fiscal Year</mat-label>
      <mat-select [(value)]="filters.fiscalYear" (selectionChange)="onFiscalYearChange($event.value)">
        <mat-option [value]="null">--</mat-option>
        @for (year of fiscalYears; track year) {
          <mat-option [value]="year">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 180px;">
      <mat-label>Region</mat-label>
      <mat-select [(value)]="filters.region" (selectionChange)="onRegionChange($event.value);">
        <mat-option [value]="null">--</mat-option>
        @for (region of regions; track region) {
          <mat-option [value]="region">{{ region }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 180px;">
      <mat-label>Forest</mat-label>
      <mat-select [(value)]="filters.forestName" (selectionChange)="onForestChange($event.value);">
        <mat-option [value]="null">--</mat-option>
        @for (forest of forestNames; track forest) {
          <mat-option [value]="forest">{{ forest }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 180px;">
      <mat-label>Treatment</mat-label>
      <mat-select [(value)]="filters.treatmentOptionId" (selectionChange)="onTreatmentChange($event.value);">
        <mat-option [value]="null">--</mat-option>
        @for (t of treatmentOptions; track t) {
          <mat-option [value]="t.id">{{ t.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </span>
  <button class="usa-button usa-button--secondary" (click)="exportToCsv()">
    <span class="export-button-text"><fa-icon class="fa-solid export-icon" [icon]="faDownload"></fa-icon>
  &nbsp;Export to CSV</span>
</button>
</div>
<table mat-table [dataSource]="summaryData" matSort>
  <ng-container matColumnDef="treatment">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Treatment</th>
    <td mat-cell *matCellDef="let row">{{ row.treatmentName }}</td>
  </ng-container>
  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Units</th>
    <td mat-cell *matCellDef="let row">{{ formatUnit(row.unitOfMeasure) }}</td>
  </ng-container>
  <ng-container matColumnDef="calendarYearAuthorized">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="gray">
      Calendar Year
    </th>
    <td mat-cell *matCellDef="let row" class="gray">{{ row.unitsAuthorized.calendarYear || 0 }}</td>
  </ng-container>
  <ng-container matColumnDef="fiscalYearAuthorized">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="gray">
      Fiscal Year
    </th>
    <td mat-cell *matCellDef="let row" class="gray">{{ row.unitsAuthorized.fiscalYear || 0 }}</td>
  </ng-container>
  <ng-container matColumnDef="calendarYearAccomplished">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="orange">
      Calendar Year
    </th>
    <td mat-cell *matCellDef="let row" class="orange">{{ row.unitsAccomplished.calendarYear || 0 }}</td>
  </ng-container>
  <ng-container matColumnDef="fiscalYearAccomplished">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="orange">
      Fiscal Year
    </th>
    <td mat-cell *matCellDef="let row" class="orange">{{ row.unitsAccomplished.fiscalYear || 0 }}</td>
  </ng-container>

  <ng-container matColumnDef="placeholder-group">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="main-header"></th>
  </ng-container>
  <ng-container matColumnDef="units-authorized-group">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" [style.text-align]="'center'" class="gray main-header">
      UNITS AUTHORIZED
    </th>
  </ng-container>
  <ng-container matColumnDef="units-accomplished-group">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" [style.text-align]="'center'" class="orange main-header">
      UNITS ACCOMPLISHED
    </th>
  </ng-container>

  <tr mat-header-row class=""
    *matHeaderRowDef="['placeholder-group', 'units-authorized-group', 'units-accomplished-group']">
  </tr>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></tr>
</table>

@if (summaryData.data?.length != this.allSummaryDataRows?.length) {
  <button aria-label="View All" class="usa-button usa-button--secondary view-all"
    (click)="loadMore()">Show All Treatments
    ({{ allSummaryDataRows.length }})
  </button>
}
